//import Vue from 'vue'
//import { USER_REQUEST, USER_ERROR, USER_SUCCESS } from '@/store/actions/user'
//import { CI_API_HOST_JS } from '@/components/constants/config'
//import { AUTH_LOGOUT } from '@/store/actions/auth'
//import axios from 'axios'
//import store from '@/store'

const state = { status: '', profile: {} }

const getters = {

}

const actions = {
  
}

const mutations = {
  
}

export default {
  state,
  getters,
  actions,
  mutations,
}
